import { useVoiceStore } from '@/store/voice'
import { cx } from '@/lib/cx'
import { SoundEmoji } from './SoundEmoji'
import styles from './EffectMark.module.css'

/**
 * Эмодзи звука, который человек только что сыграл: всплывает у имени и тает через пару секунд.
 * Видно, кто нажал «Кря», — как облачко над аватаркой у Discord.
 */
export function EffectMark({ userId, size = 16, className }: { userId: string; size?: number; className?: string | undefined }) {
  const mark = useVoiceStore((s) => s.effects[userId])
  if (!mark) return null
  return (
    <span key={mark.key} className={cx(styles.mark, className)} aria-hidden="true">
      <SoundEmoji id={mark.emoji?.id} name={mark.emoji?.name} size={size} />
    </span>
  )
}
